export class BuyerRepresentationRequest{

    public userId!:string;
    public businessId!:string;
    public propertyId!:number;
    public buyerUserName!:string;
    public buyerId!:string;
    
    constructor(){
    }
}